// removed by extract-text-webpack-plugin
module.exports = {"signupPage":"_12AJW5CRxRm8o7c8OtMY-9","signupBox":"_3XYyLrMqBZjaGp_vNXBwtZ","boxHeader":"_1ZeO8wIDYYX7ieSsSoTV52","buttonsBox":"_183rzpkXdW7yD-7ukRiM2s","logoImage":"WBwKb9YGb_jD4Udt-Y41R"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/accountPages/SignupPage.scss
// module id = 583
// module chunks = 0